/**
 * @license
 * Copyright (c) 2021 Handsoncode. All rights reserved.
 */
import { CellError } from '../Cell';
export class ParsingErrorVertex {
    constructor(errors, rawInput) {
        this.errors = errors;
        this.rawInput = rawInput;
    }
    getCellValue() {
        return CellError.parsingError();
    }
    getFormula() {
        return this.rawInput;
    }
}
